import { takeLatest, put, all, call } from 'redux-saga/effects';
import GoldUpdateLogReportTypes from './gold-price-report.types';
import { requestReportDetailsFetch } from './gold-price-report.service';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getGoldUpdateLogFailure,
	getGoldUpdateLogResponseChanged,
	getGoldUpdateLogSucess,
} from './gold-price-report.action';

/** *********************  START GOLD REPORT DETAILS  ******************** */
export function* fetchGoldLogReportDetails({ payload }: any) {
	try {
		const key = 'FetchGoldPriceDetailsKey';
		const { fromDate, toDate, databaseName, companyID, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			Limit: limit,
			ToDate: toDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(requestReportDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldUpdateLogFailure(responseData.data));
		} else {
			yield put(getGoldUpdateLogSucess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldUpdateLogFailure(error));
	}
}

export function* resetFetchGoldReportResponse() {
	yield put(getGoldUpdateLogResponseChanged());
}

export function* onFetchGoldReportResponseDetails() {
	yield takeLatest(
		GoldUpdateLogReportTypes.GET_GOLD_UPDATE_LOG_REPORT_START,
		fetchGoldLogReportDetails,
	);
}

export function* onFetchGoldReportResponseReset() {
	yield takeLatest(
		GoldUpdateLogReportTypes.GET_GOLD_UPDATE_LOG_REPORT_RESPONSE_RESET,
		resetFetchGoldReportResponse,
	);
}

/** ***************** FETCH GOLD PRICE DETAILS END *********************** */
export function* goldPriceReportSaga() {
	yield all([call(onFetchGoldReportResponseDetails), call(onFetchGoldReportResponseReset)]);
}
